import React, { useRef } from "react";
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import { DATA_TYPE } from "../../../utils/enum";
import './autoSuggest.scss'

const AutoSuggest = ({ item, handleSearch, options, index, isLoading, onChangeHandler, parentData }) => {
    const ref = useRef()
    return <div className={'autoSuggest_container'}>
        <AsyncTypeahead 
            ref={ref}
            clearButton
            newSelectionPrefix="Add new product: "
            emptyLabel={'Already in the filter'}
            allowNew={true}
            promptText={`Type ${item.title}`}
            id="async-example"
            labelKey="label"
            multiple={item?.type === DATA_TYPE.string?false:true}
            minLength={2}
            delay={500}
            maxResults={5}
            useCache={false}
            paginationText={'Load More...'}
            paginate
            isLoading={item.loading}
            onSearch={(e) => handleSearch(e, item, index)}
            options={options}
            placeholder={item.title}
            onChange={(value) => onChangeHandler(value, item, index, parentData)}
        />
  </div>;
};

export default AutoSuggest;
